import { createApi } from '@reduxjs/toolkit/query/react'

import { CONSTS } from '../config/objectConst'
import { axiosBaseQuery } from './utils/rtk'

// const baseQuery = fetchBaseQuery({
//   baseUrl: CONSTS.API.URL_AUTOMATION,

//   async prepareHeaders(headers) {
//     const token = await connectorAPI.getAccessToken();
//     headers.set("Authorization", token);
//   },
// });

export const enum Tag {
	Conversation = 'C',
	Messages = 'M',
	UnreadStats = 'U'
}

export const automationApi = createApi({
	baseQuery: axiosBaseQuery({
		baseUrl: CONSTS.API.URL_AUTOMATION
	}),
	endpoints: () => ({}),
	reducerPath: 'automationApi',
	tagTypes: [Tag.Conversation, Tag.Messages, Tag.UnreadStats]
})
